import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";

interface Bullet {
  prefix: string;
  suffix: string;
}

export interface TextGroupProps {
  id: string;
  title: string | ReactElement;
  subtitle?: string;
  bodies?: string[];
  bullets?: Bullet[];
}

export function TextGroup({
  id,
  title,
  subtitle,
  bodies,
  bullets,
}: TextGroupProps): ReactElement {
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifySelf: "center",
        textAlign: "center",
        width: { sm: 362, lg: 800 },
      }}
    >
      {typeof title === "string" ? (
        <Typography
          display="block"
          mb={subtitle ? 0 : 3}
          variant="h3"
          textAlign={"center"}
        >
          {title}
        </Typography>
      ) : (
        title
      )}
      {subtitle && (
        <Typography
          display="block"
          mb={3}
          variant="h3"
          width={{ sm: 362, lg: 600 }}
          textAlign={"center"}
        >
          {subtitle}
        </Typography>
      )}
      {bodies && (
        <Stack
          sx={{
            maxWidth: { sm: 362, lg: 600 },
            textAlign: "left",
            width: { sm: 362, lg: 600 },
          }}
        >
          {bodies.map((body, idx) => (
            <Typography
              key={`${id}-bodies-${idx.toString()}`}
              mb={3}
              variant="body1"
            >
              {body}
            </Typography>
          ))}
        </Stack>
      )}
      {bullets && (
        <Stack
          sx={{
            maxWidth: { sm: 362, lg: 600 },
            textAlign: "left",
            width: { sm: 362, lg: 600 },
          }}
        >
          <ul>
            {bullets.map((bullet, idx) => (
              <li key={`${id}-bullets-${idx.toString()}`}>
                <Typography variant="body1">
                  <b>{bullet.prefix}</b>
                  {bullet.suffix}
                </Typography>
              </li>
            ))}
          </ul>
        </Stack>
      )}
    </Stack>
  );
}
